import {Component, Input, OnInit} from '@angular/core';


export interface IExpandableInformationBoxText {
  label: string;
  content: string;
  id: string;
}

@Component({
  selector: 'app-expandable-information-box',
  templateUrl: './expandable-information-box.component.html',
  styleUrls: ['./expandable-information-box.component.scss']
})

export class ExpandableInformationBoxComponent implements OnInit{


  get label(): string {
    return this.infoText?.label;
  }
  get content(): string {
    return this.infoText?.content;
  }
  get id(): string {
    return this.infoText?.id;
  }

  @Input() infoText: IExpandableInformationBoxText;

  constructor() {
  }

  ngOnInit(): void {
  }

}
